import { any, async, fromJSX, loadingAsyncState, nothing, stateful } from "widgets-for-react";
import { getBlogs } from "./blogOverviewApi";
import { BlogOverviewLayout } from "./blogOverviewLayout";
import { initialBlogResponse as initialBlogsResponse, initialState, resultsClass } from "./blogOverviewState";
export const BlogOverview = (props)=>stateful()((s0)=>any()([
            fromJSX((setState)=>BlogOverviewLayout({
                    ...s0,
                    ...props,
                    key: 'blogOverview',
                    setPage: (page)=>setState((s0)=>({
                                ...s0,
                                currentPage: page,
                                blogpostLoader: loadingAsyncState(getBlogs(page, props.pageSize, s0.selectedCategory), previousBlogsResponse(s0))
                            })),
                    setCategory: (newCategory)=>setState((s0)=>{
                            // Always go to the first page when switching category
                            const currentPage = 1;
                            // Clicking the active Category a second time will turn of category filtering
                            const selectedCategory = newCategory == s0.selectedCategory ? null : newCategory;
                            const fetcher = getBlogs(currentPage, props.pageSize, selectedCategory);
                            const blogpostLoader = loadingAsyncState(fetcher, previousBlogsResponse(s0));
                            return {
                                ...s0,
                                selectedCategory,
                                blogpostLoader,
                                currentPage
                            };
                        })
                })),
            async(nothing, {
                key: 'blogsLoader'
            })(s0.blogpostLoader).map((postsUpdater)=>(s1)=>{
                    const blogpostLoader = postsUpdater(s1.blogpostLoader);
                    if (blogpostLoader.kind == 'loaded') scrollResultsToTop();
                    return {
                        ...s1,
                        blogpostLoader
                    };
                })
        ]).map((a)=>a(s0)))(initialState(props)).run((_)=>{});
const previousBlogsResponse = (s0)=>s0.blogpostLoader.kind == 'loading' || s0.blogpostLoader.kind == 'loaded' ? s0.blogpostLoader.value : initialBlogsResponse;
const scrollResultsToTop = ()=>document.getElementsByClassName(resultsClass)[0].scrollIntoView({
        behavior: "smooth"
    });
